/* Product artwork paths come back from the catalog as CDN-relative paths carrying a
 * `{DPI_CLASS}` placeholder, e.g.
 *   consumables/spotlights/icons/{DPI_CLASS}/spotlight_10pt.png
 * The client resolves them against the consumables asset host, which is served by the
 * config service as `consumables.assetsBaseUrl` - the same key and join that web-live
 * uses for boost artwork.
 */

// Available sizes are 160, 240, 320, 400, 480 and 640. 320 keeps a list thumbnail crisp
// on retina displays without pulling the largest asset.
export const DEFAULT_DPI_CLASS = '320';

/**
 * Resolve a catalog asset path against the asset host.
 *
 * @param {string} assetsBaseUrl
 * @param {string} path catalog-relative path, possibly containing `{DPI_CLASS}`
 * @param {string} [dpiClass]
 * @returns {string|null} null when either the host or the path is unavailable
 */
export function buildAssetUrl(assetsBaseUrl, path, dpiClass = DEFAULT_DPI_CLASS) {
  if (!assetsBaseUrl || !path) {
    return null;
  }

  const base = assetsBaseUrl.replace(/\/+$/, '');
  const resolved = path.replace(/^\/+/, '').replace('{DPI_CLASS}', dpiClass);

  return `${base}/${resolved}`;
}

/**
 * The list thumbnail for a catalog product.
 *
 * @param {object} product
 * @param {string} assetsBaseUrl
 * @returns {string|null}
 */
export function getProductThumbnailUrl(product, assetsBaseUrl) {
  const { details: { thumbnail } = {} } = product || {};

  return buildAssetUrl(assetsBaseUrl, thumbnail);
}
